export default __webpack_public_path__ + "static/media/recruit_design_pic.54d9ed5f.png";